import { AppNamespace } from '../state/app';

export const createMockAppState: (
    overrides?: Partial<AppNamespace>,
) => AppNamespace = (overrides) => ({
    appVersion: 'appVersion',
    ebDomain: 'eventbrite.com',
    event: {
        id: 'eventId',
        organizer_id: 'organizer_id',
    },
    isEventbriteTLD: true,
    locale: 'locale',
    featureFlags: {},
    defaultUserCountry: '',
    locales: [],
    request: {
        correlation_id: 'correlation_id',
        session_id: 'session_id',
        params: {},
    },
    ...overrides,
    useIosProfile: false,
    useAndroidProfile: false,
});

export const getUserTrackingIDs = ({ event, request }: AppNamespace) => ({
    correlationId: request?.correlation_id,
    eventId: event?.id,
    organizerId: event?.organizer_id,
    sessionId: request?.session_id,
});
